import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../api'

// Fetch all modifiers
const fetch = async () => {
  const res = await api.get('/categories/all')
  return res.data.data
}

// Create a new modifier
const create = async (data) => {
  const res = await api.post('/categories', data)
  return res.data.data
}
// PUT: Update a modifier by ID
const update = async ({ id, data }) => {
  const res = await api.post(`/categories/${id}`, data)
  return res.data
}
const remove = async (id) => {
  const res = await api.delete(`/categories/${id}`)
  return res.data
}
const useCategory = () => {
  const queryClient = useQueryClient()

  // GET
  const query = useQuery({
    queryKey: ['category'],
    queryFn: fetch,
    staleTime: 1000 * 60 * 60, // for caching
  })

  // POST
  const mutation = useMutation({
    mutationFn: create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['category'], exact: false })
    },
  })
  // put
  const updateMutation = useMutation({
    mutationFn: update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['category'], exact: false })
    },
  })
  // put
  const deleteMutation = useMutation({
    mutationFn: remove,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['category'], exact: false })
    },
  })
  return {
    ...query, // isLoading, data, error, etc.
    create: mutation.mutate, // call this to POST
    isCreating: mutation.isPending,
    createError: mutation.error,
    createSuccess: mutation.isSuccess,

    update: updateMutation.mutate,
    isUpdating: updateMutation.isPending,
    updateError: updateMutation.error,
    updateSuccess: updateMutation.isSuccess,

    remove: deleteMutation.mutate,
    isRemoving: deleteMutation.isPending,
    removeError: deleteMutation.error,
    removeSuccess: deleteMutation.isSuccess,
  }
}

export default useCategory
